UserSessionStorageService.$inject = [
  'LocalStorageService',
  'credentials'
];

export function UserSessionStorageService(LocalStorageService, credentials) {

  function toObject(val) {
    if (val) {
      try {
        return JSON.parse(val);
      } catch (e) {}
    }
    return val;
  }

  var STORAGE_KEY = '__user_session_' + credentials.userId;

  var userSessionStorage = {
    storage: undefined, //will get initialize
    _load: function() {
      return (userSessionStorage.storage = toObject(
        LocalStorageService.getGlobal(STORAGE_KEY) || '{}'
      ));
    },
    _saveLocal: function() {
      LocalStorageService.setGlobal(
        STORAGE_KEY,
        JSON.stringify(userSessionStorage.storage)
      );
    },
    save: function(storageName, object) {
      userSessionStorage.storage[storageName] = object;
      userSessionStorage._saveLocal();
    },
    remove: function(storageName) {
      delete userSessionStorage.storage[storageName];
      userSessionStorage._saveLocal();
    },
    clear: function() {
      userSessionStorage.storage = {};
      userSessionStorage._saveLocal();
    }
  };
  //init
  userSessionStorage._load();
  return {
    clearSession: userSessionStorage.clear,
    /** create a named storage object */
    createStorage: function(name) {
      var storage = {
        name: name,
        load: function() {
          return toObject(userSessionStorage._load()[storage.name]);
        },
        loadWithDefaults: function(defaultValue) {
          var obj = storage.load();
          return obj ? obj : defaultValue;
        },
        save: function(newObject) {
          userSessionStorage.save(storage.name, JSON.stringify(newObject));
        },
        clear: function() {
          userSessionStorage.remove(storage.name);
        }
      };
      return storage;
    }
  };
}

